import type { RouterEvent } from "next/router";
import Router from "next/router";
import { useEffect } from "react";

export function useRouterEvents(
  event: RouterEvent,
  callback: (...evts: any[]) => void
) {
  useEffect(() => {
    Router.events.on(event, callback);

    return () => Router.events.off(event, callback);
  }, [callback, event]);
}
